import { environment as base } from "./environment.base";

export const environment = {
  ...base,
  code: 'cirt',
  dashboard: '',
  ga: 'G-YLC898JNLR'
};
